import { useState, useEffect } from 'react';
import OutrunSun from './OutrunSun';
import ScanLines from './ScanLines';

const SynthwaveAesthetics = () => {
  // Check dark mode directly from DOM to avoid context re-render loops
  const [isDarkMode, setIsDarkMode] = useState(() =>
    document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    // Only check on mount - don't watch for changes to avoid re-renders
    setIsDarkMode(document.documentElement.classList.contains('dark'));
  }, []); // Empty deps - only run once

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: -1,
      }}
      aria-hidden="true"
    >
      {/* Layer 1: Outrun sun */}
      <div style={{ opacity: isDarkMode ? 0.5 : 0.3 }}>
        <OutrunSun />
      </div>

      {/* Layer 2: Horizontal scan lines */}
      <ScanLines isDarkMode={isDarkMode} />
    </div>
  );
};

export default SynthwaveAesthetics;
